import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { T } from '../../../i18n';
export const ErrorFallback = () => (_jsx(Card, { children: _jsx(Card.Content, { children: _jsx("h4", { children: _jsx(T, { id: "Generics.SomethingWentWrong", defaultMessage: "Something went wrong" }, void 0) }, void 0) }, void 0) }, void 0));
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error({ error, errorInfo });
        const { onError } = this.props;
        if (typeof onError === 'function') {
            onError(error, errorInfo);
        }
    }
    render() {
        const { hasError } = this.state;
        const { fallback, children } = this.props;
        if (hasError) {
            // You can render any custom fallback UI
            return fallback || _jsx(ErrorFallback, {}, void 0);
        }
        return children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map